"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = PremiumContentBlockCard;
const react_1 = __importDefault(require("react"));
const PremiumContentBlockCard_module_scss_1 = __importDefault(require("./PremiumContentBlockCard.module.scss"));
const Button_1 = require("@JohnLewisPartnership/jl-design-system/dist/components/button/Button");
const buildImageUrl_1 = require("../../utils/buildImageUrl");
const dispatchAnalytics_1 = require("../../utils/dispatchAnalytics");
const LOGO_POSITION_CLASS = {
    "Top Left": PremiumContentBlockCard_module_scss_1.default.logoTopLeft,
    "Bottom Left": PremiumContentBlockCard_module_scss_1.default.logoBottomLeft,
    "Top Right": PremiumContentBlockCard_module_scss_1.default.logoTopRight,
    "Bottom Right": PremiumContentBlockCard_module_scss_1.default.logoBottomRight,
    Top: PremiumContentBlockCard_module_scss_1.default.logoGroupTop,
    Bottom: PremiumContentBlockCard_module_scss_1.default.logoGroupBottom,
    Left: PremiumContentBlockCard_module_scss_1.default.logoGroupLeft,
    Right: PremiumContentBlockCard_module_scss_1.default.logoGroupRight,
};
const LOGO_IMAGE_PARAMS = { fmt: "auto", wid: "120" };
const PREVIEWER_IMAGE_SIZE = {
    mobile: "343",
    tablet: "582",
    desktop: "902",
};
const PREVIEWER_LOGO_SIZE = {
    mobile: "75",
    tablet: "128",
    desktop: "198",
};
function LogoOverlay({ logoImage, logoAccessibilityText, logoPosition, logo2Image, logo2AccessibilityText, previewerSize, }) {
    const logoParams = previewerSize
        ? { fmt: "auto", wid: PREVIEWER_LOGO_SIZE[previewerSize] }
        : LOGO_IMAGE_PARAMS;
    const logo1Src = (0, buildImageUrl_1.buildImageUrl)(logoImage, logoParams);
    const logo2Src = logo2Image
        ? (0, buildImageUrl_1.buildImageUrl)(logo2Image, logoParams)
        : undefined;
    const logoClassName = previewerSize
        ? PremiumContentBlockCard_module_scss_1.default[`preview-logo-${previewerSize}`]
        : PremiumContentBlockCard_module_scss_1.default.logo;
    return (react_1.default.createElement("div", { className: `${PremiumContentBlockCard_module_scss_1.default.logoWrapper} ${LOGO_POSITION_CLASS[logoPosition]}` },
        react_1.default.createElement("img", { src: logo1Src, alt: logoAccessibilityText, className: logoClassName, "data-testid": "premium-content-block-card-logo-1" }),
        logo2Src && (react_1.default.createElement("img", { src: logo2Src, alt: logo2AccessibilityText || "", className: logoClassName, "data-testid": "premium-content-block-card-logo-2" }))));
}
function PremiumContentBlockCard({ associatedAdvertId, clickUrl, impressionUrl, title, description, desktopImage, accessibilityText, ctaLink, ctaText = "Shop now", logoImage, logoAccessibilityText, logoPosition, logo2Image, logo2AccessibilityText, previewerSize, esiType, }) {
    const imageSize = previewerSize
        ? PREVIEWER_IMAGE_SIZE[previewerSize]
        : "1274";
    const imageSrc = (0, buildImageUrl_1.buildImageUrl)(desktopImage, {
        fmt: "auto",
        wid: imageSize,
        sm: "aspect",
        aspect: "1:1",
    }, { applyPoi: true });
    const imageContainerClassName = previewerSize
        ? PremiumContentBlockCard_module_scss_1.default[`preview-imageContainer-${previewerSize}`]
        : PremiumContentBlockCard_module_scss_1.default.imageContainer;
    const contentClassName = previewerSize
        ? PremiumContentBlockCard_module_scss_1.default[`preview-content-${previewerSize}`]
        : PremiumContentBlockCard_module_scss_1.default.content;
    const titleClassName = previewerSize
        ? PremiumContentBlockCard_module_scss_1.default[`preview-title-${previewerSize}`]
        : PremiumContentBlockCard_module_scss_1.default.title;
    const descriptionClassName = previewerSize
        ? PremiumContentBlockCard_module_scss_1.default[`preview-description-${previewerSize}`]
        : PremiumContentBlockCard_module_scss_1.default.description;
    const ctaContainerClassName = previewerSize
        ? PremiumContentBlockCard_module_scss_1.default[`preview-ctaContainer-${previewerSize}`]
        : PremiumContentBlockCard_module_scss_1.default.ctaContainer;
    return (react_1.default.createElement("a", { href: ctaLink, className: PremiumContentBlockCard_module_scss_1.default.card, "data-testid": "premium-content-block-card", onClick: () => {
            (0, dispatchAnalytics_1.dispatchKevelAnalyticsEvent)({
                action: "kevel.clicked",
                type: "banner",
                adId: associatedAdvertId,
                clickUrl,
                impressionUrl,
                esiType,
            });
        } },
        react_1.default.createElement("div", { className: imageContainerClassName },
            previewerSize ? (react_1.default.createElement("img", { src: imageSrc, alt: accessibilityText, className: PremiumContentBlockCard_module_scss_1.default["preview-image"], "data-testid": "premium-content-block-card-image" })) : (react_1.default.createElement("picture", null,
                react_1.default.createElement("source", { media: "(min-width: 600px)", srcSet: imageSrc }),
                react_1.default.createElement("img", { src: imageSrc, alt: accessibilityText, className: PremiumContentBlockCard_module_scss_1.default.image, "data-testid": "premium-content-block-card-image" }))),
            react_1.default.createElement(LogoOverlay, { logoImage: logoImage, logoAccessibilityText: logoAccessibilityText, logoPosition: logoPosition, logo2Image: logo2Image, logo2AccessibilityText: logo2AccessibilityText, previewerSize: previewerSize })),
        react_1.default.createElement("div", { className: contentClassName },
            react_1.default.createElement("h3", { className: titleClassName, "data-testid": "premium-content-block-card-title" }, title),
            react_1.default.createElement("p", { className: descriptionClassName, "data-testid": "premium-content-block-card-description" }, description),
            react_1.default.createElement("div", { className: ctaContainerClassName, "data-testid": "premium-content-block-card-cta" },
                react_1.default.createElement(Button_1.UnderlinedButton, { tag: "span", labelText: ctaText })))));
}
